import * as React from 'react';

export default class NeedsCalculationRow extends React.Component {
    render() {
        if (this.props.model) {
            return (<tr className={this.getRowClass()} onClick={() => this.props.onClick(this.props.model.id.value)}>
                <td>{this.props.model.power.value}</td>
                <td>{this.props.model.storage.value}</td>
                <td>{this.props.model.operatingMode.items[this.props.model.operatingMode.value].text}</td>
                <td>{this.props.model.loadTimeWithRecyclingFlowRateHumanized.value}</td>
                <td>{this.isSelected() && this.renderDot()}</td>
                {/*<td>{this.props.model.loadTimeWithoutRecyclingFlowRate}</td>*/}
            </tr>)
        } else {
            return (<React.Fragment></React.Fragment>);
        }
    }

    renderDot() {
        return (
            <span className="dot"/>
        )
    }

    isSelected() {
        return this.props.selectedId.value === this.props.model.id.value;
    }

    getRowClass() {
        return this.isSelected() ? 'selected' : '';
    }
}
